document.addEventListener('DOMContentLoaded', function () {

    // === 1. Hero Banner Check ===
    const firstChild = document.querySelector('.main-content > .index-section--hero');
    if (firstChild) {
        document.body.classList.add('has-banner');
    }

    // === 2. Cart + Menu Interaction ===
    const siteHeaderElement = document.querySelector(".site-header__element");
    if (siteHeaderElement) {
        document.addEventListener("cart:open", function () {
            const navTrigger = siteHeaderElement.querySelector('.nav-trigger--initialized');
            if (navTrigger && navTrigger.classList.contains("is-active")) {
                navTrigger.dispatchEvent(new Event('click', { bubbles: false }));
            }
        });
    }

    // === 3. Footer Accordion (Mobile only) ===
    let isFooterEventBound = false;

    function initFooterAccordion() {
        if (window.innerWidth < 768) {
            if (!isFooterEventBound) {
                document.querySelectorAll('.footer__title').forEach(title => {
                    title.addEventListener('click', function () {
                        this.classList.toggle('toggle-open');
                        const content = this.nextElementSibling;
                        if (content) {
                            content.style.display = content.style.display === 'block' ? 'none' : 'block';
                        }
                    });
                });
                isFooterEventBound = true;
            }
        } else if (isFooterEventBound) {
            // Note: Removing listeners is complex in vanilla, so we just ignore on desktop
            isFooterEventBound = false;
        }
    }

    initFooterAccordion();
    window.addEventListener('resize', initFooterAccordion);

    // === 4. Optimized Scroll Handler ===
    let lastScrollTop = 0;
    let ticking = false;

    function onScroll() {
        const st = window.scrollY;

        // Scroll direction
        if (st > lastScrollTop && st > 10) {
            document.body.classList.add("scroll-down");
            document.body.classList.remove("scroll-up");
        } else if (st < lastScrollTop) {
            document.body.classList.remove("scroll-down");
            document.body.classList.add("scroll-up");
        }

        if (st > 10) {
            document.body.classList.add('scroll');
        } else {
            document.body.classList.remove('scroll');
        }

        lastScrollTop = st;

        updateHeaderColor(st);
        ticking = false;
    }

    function updateHeaderColor(scrollTop) {
        const header = document.querySelector(".header-section");
        if (!header) return;

        let isInsideLightBg = false;

        document.querySelectorAll(".shopify-section.light-bg").forEach(section => {
            const rect = section.getBoundingClientRect();
            const sectionTop = rect.top + window.scrollY;
            const sectionBottom = sectionTop + rect.height;

            if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
                isInsideLightBg = true;
                return false; // break
            }
        });

        if (isInsideLightBg) {
            header.classList.add("change-color");
        } else {
            header.classList.remove("change-color");
        }
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(onScroll);
            ticking = true;
        }
    }, { passive: true });

    // === 5. Header Hover (Desktop) ===
    document.querySelectorAll('.header-wrapper .site-nav__item.site-nav--has-dropdown').forEach(item => {
        item.addEventListener('mouseenter', function () {
            this.closest('.site-header__element')?.classList.add('open-sub-menu');
        });
        item.addEventListener('mouseleave', function () {
            this.closest('.site-header__element')?.classList.remove('open-sub-menu');
        });
    });

    // === 6. Active Navigation ===
    const currentPath = window.location.pathname;

    document.querySelectorAll('summary[data-link]').forEach(summary => {
        if (summary.getAttribute('data-link') === currentPath) {
            summary.closest('li.site-nav__item')?.classList.add('active');
        }
    });

    document.querySelectorAll('.site-nav__dropdown-link').forEach(link => {
        if (link.getAttribute('href') === currentPath) {
            link.classList.add('active');
            link.closest('li')?.classList.add('active');
            link.closest('li.site-nav__item')?.classList.add('active');
        }
    });

    // === 7. Header Height + CSS Variables ===
    function updateHeaderHeight() {
        const header = document.querySelector('.site-header');
        if (header) {
            const height = header.offsetHeight;
            document.documentElement.style.setProperty('--height-header', height + 'px');
        }
    }

    function updateAppHeight() {
        document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
    }

    // Initial setup
    updateHeaderHeight();
    updateAppHeight();

    // Throttled resize
    let resizeTicking = false;
    window.addEventListener('resize', () => {
        if (!resizeTicking) {
            requestAnimationFrame(() => {
                updateHeaderHeight();
                updateAppHeight();
            });
            resizeTicking = true;
        }
    });

    // === Search Button ===
    document.querySelectorAll('.header-item--search .site-nav__compress-menu').forEach(btn => {
        btn.addEventListener('click', function () {
            document.querySelector('header-section')?.classList.remove('cart-open');
            document.body.classList.toggle('open-menu');
        });
    });

});